/**
 * مشکل‌های ثبت‌شده روی رخدادها (جدولِ `item_issues`، مایگریشن 0082).
 *
 * سه تا متد، و هر سه عمداً کوچیک‌ان: منطقِ فهرست توی `lib/issues.ts` است و
 * این‌جا فقط رفت‌وبرگشتِ دیتابیسه.
 *
 * ⚠ `list()` **همه‌ی** سطرهای منه، نه سطرهای یه رخداد. دلیلش خودِ خواسته‌ست:
 * فهرستی که دکمه باز می‌کنه، مشکل‌هایی‌ست که تا حالا روی **هر** رخدادی نوشتم.
 * پس یه کوئری برای کلِ صفحه (نه یکی به‌ازای هر کارت) و بقیه‌ش محاسبه‌ی محلی —
 * همون کاری که `useFavorites` می‌کنه. سیاستِ RLS هم تضمین می‌کنه چیزی جز
 * سطرهای خودِ صداکننده برنگرده، پس فیلترِ `user_id` این‌جا لازم نیست.
 *
 * و حجمش نگران‌کننده نیست: این جدول فقط با دستِ یه نفر پر می‌شه.
 */
import { supabase } from '../lib/supabase';
import { isDemoMode } from '../lib/demo';
import { normalizeIssue, type ItemIssue } from '../lib/issues';
import type { UserId } from '../domain/types';

/* eslint-disable @typescript-eslint/no-explicit-any */

export const issueRepo = {
  /** همه‌ی مشکل‌هایی که ثبت کرده‌ام، روی هر رخدادی. */
  async list(): Promise<ItemIssue[]> {
    // دمو نه حسابِ صاحبِ پروژه داره نه سروری برای پرسیدن؛ فهرستِ خالی یعنی
    // دکمه هم اصلاً چیزی برای نشون دادن نداره.
    if (isDemoMode) return [];
    const { data, error } = await supabase
      .from('item_issues')
      .select('id, event_id, text, created_at')
      .order('created_at', { ascending: false });
    if (error) throw error;
    return (data ?? []).map((r: any) => ({
      id: Number(r.id), eventId: r.event_id, text: r.text, createdAt: r.created_at,
    }));
  },

  /** «این مشکل روی این رخداد هم هست.» */
  async add(eventId: string, text: string, uid: UserId): Promise<void> {
    if (isDemoMode) return;
    const { error } = await supabase.from('item_issues')
      .insert({ event_id: eventId, user_id: uid, text: normalizeIssue(text) });
    // ردیفِ تکراری یعنی از قبل ثبت شده — خطا نیست (همون قاعده‌ی favoriteRepo).
    if (error && error.code !== '23505') throw error;
  },

  /** پس گرفتنِ همون انتخاب. */
  async remove(eventId: string, text: string): Promise<void> {
    if (isDemoMode) return;
    const { error } = await supabase.from('item_issues')
      .delete().eq('event_id', eventId).eq('text', normalizeIssue(text));
    if (error) throw error;
  },
};
